import React, { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";

const OverRideAlert = ({
  objectData,
  fromAutosave = false,
  fromLayout = false,
  setLoading,
  setIsOverRide,
  isOverRide,
  isOverideLoad,
  overRideConfirmHandler,
  overRideCancel,
  fromConservation = false,
}) => {
  useEffect(() => {
    Swal.fire({
      html: fromAutosave
        ? `<span style="font-size:20px;">Someone has already made some changes in object ${
            fromConservation
              ? objectData?.object_details?.object_name
              : objectData?.object_name
          } (${
            fromConservation
              ? objectData?.object_details?.accession_number
              : objectData?.accession_number
          }). Do you want to</span>`
        : `<span style="font-size:20px;">Someone has already made some changes in this object. Do you want to</span>`,
      customClass: {
        container: "custom-alert-container",
        header: "custom-alert-header",
        title: "custom-alert-title",
        cancelButton: "alert-cancel",
        confirmButton: "alert-confirm",
      },
      showCloseButton: fromLayout ? false : true,
      icon: "question",
      confirmButtonText: "Override",
      confirmButtonColor: "#20409A",
      cancelButtonColor: "#fff",
      showCancelButton: true,
      iconColor: "#20409A",
      allowOutsideClick: !fromLayout,
      allowEscapeKey: !fromLayout,
      didOpen: () => {
        if (isOverideLoad) Swal.showLoading();
      },
    }).then((result) => {
      // ✅ Confirm clicked
      if (result.isConfirmed) {
        overRideConfirmHandler();
      }
      // ✅ Cancel button clicked
      else if (result.dismiss === Swal.DismissReason.cancel) {
        overRideCancel(false);
      }
      // ✅ Close button (X) clicked OR click outside OR press Esc
      else if (
        result.dismiss === Swal.DismissReason.close ||
        result.dismiss === Swal.DismissReason.backdrop ||
        result.dismiss === Swal.DismissReason.esc
      ) {
        // just set override false (reset)
        overRideCancel(true);
      }
    });
  }, []);
};

export default OverRideAlert;
